import { gql } from '@apollo/client';

export const fetchInvoicesForInvoiceGroupPage = gql`
  query fetchInvoicesForInvoiceGroupPageV2(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    invoiceGroup(id: $id) {
      id
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          status
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          creditCardMaskedNumber
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          purchaseOrderNumber
          pdfLink
          refunds {
            id
            type
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          dunningStatus {
            errorCode
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
